<script lang="ts">
  import type { CustomBlockComponentProps } from "@portabletext/svelte";
  import type { ImageWithMeta, SanityPicture } from "../types/shared";
  import Picture from "$lib/SanityPicture.svelte";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import { getSanityPictureObject } from "$lib/utils/getSanityPictureObject";

  let {
    class: classes = "",
    portableText,
  }: {
    class?: string;
    portableText: CustomBlockComponentProps<ImageWithMeta>;
  } = $props();
  let image: null | SanityPicture = $derived(
    portableText?.value
      ? {
          ...getSanityPictureObject(portableText?.value, {
            sizes: [[1000], [1800]],
            fit: "min",
          }),
        }
      : null
  );

</script>

<p
  class={["image-component-container italic", classes]}
  data-aspectRatio={portableText?.value?.asset?.metadata?.dimensions?.aspectRatio}
>
  {#if image}
    <Picture
      class={[!image.width && !image.height && "w-full"]}
      pictureObject={image}
      alt={image.alt || ""}
      sizes={`(min-width: ${br.desktop}) 65vw, (min-width: ${br.laptop}) 75vw, 100vw`}
    />
  {/if}
</p>
